import { Space, Tag } from 'antd';
import { useIntl } from 'react-intl';

import {
    aggregateReportReasons,
    formatReportTypeLabel,
    getReportTypeMeta,
} from '@/pages/ugc-reports/utils';

import type { ReportReasonDictionary } from '@/pages/ugc-reports/utils';
import type { UgcReportLog } from '@/services/ugc-reports';

type Props = {
    logs?: UgcReportLog[];
    dictionary?: ReportReasonDictionary;
};

const ReportReasonSummary: React.FC<Props> = ({ logs, dictionary = 'content' }) => {
    const { formatMessage, messages } = useIntl();
    const items = aggregateReportReasons(logs);

    if (!items.length) return <>-</>;

    return (
        <Space wrap size={[4, 4]}>
            {items.map(({ code, count }) => {
                const meta = getReportTypeMeta(code, dictionary);
                const label = formatReportTypeLabel(
                    code,
                    dictionary,
                    formatMessage,
                    messages as Record<string, unknown>,
                );
                const text = formatMessage(
                    { id: 'ugcReports.reasonSummaryItem' },
                    { label, count },
                );
                return (
                    <Tag key={code} color={meta?.color ?? 'default'}>
                        {text}
                    </Tag>
                );
            })}
        </Space>
    );
};

export default ReportReasonSummary;
